export default "<option value=\"{{- value}}\">\n\n    <js-templateNonce></js-templateNonce>\n    {{- text}}</option>";